import type { SharedData } from '@/types';
import { usePage } from '@inertiajs/vue3';
import { defineStore } from 'pinia';

const page = usePage<SharedData>();

export type VatState = {
    showPreviousSubmission: boolean;
    date: string;
    selectedGrouping: string;
};

export const useVatStore = defineStore('vat', {
    state: (): VatState => ({
        showPreviousSubmission: false,
        date: page.props.auth.user.reporting_full_date,
        selectedGrouping: 'my_clients',
    }),
    actions: {
        toggleShowPreviousSubmission() {
            this.showPreviousSubmission = !this.showPreviousSubmission;
        },
        setDate(date: string) {
            this.date = date;
        },
        setSelectedGrouping(grouping: string) {
            this.selectedGrouping = grouping;
        },
    },
});
